import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import DatePicker from 'components/DatePicker';
import TimeInput from 'components/TimeInput';
import { Button } from 'react-toolbox';

import styles from 'styles/input.scss';
import formStyles from 'styles/form.scss';

class UpdateDueDate extends React.Component {
  state = { dueDate: '', dueTime: '' }

  componentDidMount = () => this.setDueDate();

  componentWillReceiveProps = nextProps => (nextProps.value !== !this.props.value ?
      this.setDueDate(nextProps) : null);

  onBlur = () => {
    if (this.props.onChange) {
      const { dueDate, dueTime } = this.state;
      let dueDateTime = moment(`${dueDate} ${dueTime}`, 'MM/DD/YYYY HH:mm');
      if (dueDateTime.isBefore(moment(`${dueDate} 08:00`, 'MM/DD/YYYY HH:mm'))) {
        dueDateTime = moment(`${dueDate} 08:00`, 'MM/DD/YYYY HH:mm');
      }
      this.props.onChange(dueDateTime.toISOString());
    }
  }

  setDueNow = () => {
    const time = moment().format('HH:mm');
    const date = moment().format('MM/DD/YYYY');
    this.setState({ dueDate: date, dueTime: time }, this.onBlur);
  }

  setDueDate = (props = this.props) => {
    const dueAt = moment(props.value);
    if (!dueAt.isValid()) return;
    this.setState({
      dueDate: dueAt.format('MM/DD/YYYY'),
      dueTime: dueAt.format('HH:mm'),
    });
  }

  handleDateChange = (dueDate) => {
    this.state = { ...this.state, dueDate };
    this.setState(this.state);
  }

  handleTimeChange = dueTime => this.setState({ dueTime });

  render = () => {
    const { dueDate, dueTime } = this.state;
    const { dateLabel, timeLabel, required, errors } = this.props;
    return (<div>
      {moment().isSameOrAfter(moment().startOf('day').add(8, 'hours')) && <Button
        label="Due Now"
        className={formStyles.sidebarButton}
        onClick={this.setDueNow}
      />}
      <div className={formStyles.row}>
        <DatePicker
          label={dateLabel}
          value={dueDate}
          onChange={this.handleDateChange}
          onBlur={this.onBlur}
          className={styles.datepicker}
          placeholder="Select Date"
          required={required}
          error={errors.due_at || errors.dueAt}
        />
        <TimeInput
          label={timeLabel}
          value={dueTime}
          onChange={this.handleTimeChange}
          onBlur={this.onBlur}
          errors={errors.due_at}
          required={required}
          setMin
        />
      </div>
    </div>);
  }
}

UpdateDueDate.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    due_at: PropTypes.arrayOf(PropTypes.string),
  }),
  dateLabel: PropTypes.string.isRequired,
  timeLabel: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
};

UpdateDueDate.defaultProps = {
  dateLabel: 'Date',
  timeLabel: 'Time',
  required: true,
};

export default UpdateDueDate;



// WEBPACK FOOTER //
// ./client/app/shared/components/UpdateDueDate/index.jsx